import React from 'react';
import { Navigate } from 'react-router-dom';
import { lazyPage } from '../utils/lazyPage';

// Imported one by one, never through the `pages` barrel (src/pages/index.js):
// the barrel re-exports the homepage and every market page, so importing two
// small pages from it put all of them in the entry bundle.
const Home = lazyPage(() => import('pages/IndexPage'));
const Welcome = lazyPage(() => import('pages/Welcome'));
const Start = lazyPage(() => import('pages/Start'));
const Founding50 = lazyPage(() => import('pages/Founding50'));
const EmailConfirmation = lazyPage(() => import('pages/EmailConfirmation/EmailConfirmation'));
const Login = lazyPage(() => import('pages/Login/Login'));
const Upgrade = lazyPage(() => import('pages/Upgrade/Upgrade'));
// Shared with /sitemap in src/Routes.js: one wrapper, so one loaded module.
export const Sitemap = lazyPage(() => import('../components/Sitemap'));

const routes = [
  {
    path: '/',
    renderer: (params = {}) => <Home {...params} />,
    public: true
  },
  {
    path: '/sitemap.xml',
    renderer: () => <Sitemap />
  },
  {
    path: '/confirm-email',
    renderer: (params = {}) => <EmailConfirmation {...params} />,
    public: true
  },
  {
    path: '/login',
    renderer: () => <Login />,
    public: true
  },
  {
    // Public pricing page and the /pricing 301 target (#280). Prerendered as the
    // logged-out page (reactSnap.include, NOINDEX_PRERENDER_OK) so the plan
    // facts are in the server HTML; it never redirects.
    path: '/upgrade',
    renderer: () => <Upgrade />,
    public: true
  },
  {
    // One-time onboarding (#184). Not indexable: noindex in the manifest and
    // Disallowed in robots.txt, like /login.
    path: '/welcome',
    renderer: () => <Welcome />,
    public: true
  },
  {
    // Paid X Ads door (#253). noindex in the manifest and in its own head, and
    // out of the sitemap. Prerendered all the same (reactSnap.include, and the
    // NOINDEX_PRERENDER_OK exception in check-prerender-coverage.js) so the hero
    // paints before the bundle runs. Not Disallowed in robots.txt: a crawler has
    // to fetch it to see noindex.
    path: '/start',
    renderer: () => <Start />,
    public: true
  },
  {
    // Founding 50 offer (#317), linked from emails, posts and ads. noindex and
    // out of the sitemap like /start (time-boxed promo), prerendered all the
    // same (reactSnap.include + NOINDEX_PRERENDER_OK). The server decides
    // which of its four states shows, via /api/founding50/status.
    path: '/founding50',
    renderer: () => <Founding50 />,
    public: true
  },
  {
    path: '/upgrade/success',
    renderer: () => <Navigate to="/account?upgrade=success" replace />,
    public: true
  },
];

export default routes;